import { Link, useLocation, useParams } from 'react-router-dom';

const Breadcrumb = ({ topics, texts }) => {
    const location = useLocation();
    const { topicId } = useParams();

    const topicName = topics.find(topic => topic.ID === Number(topicId))?.title || '';

    const isStart = location.pathname === '/';
    const isInTopics = location.pathname.includes("/topics");
    const isInTopic = location.pathname.includes("/statement");
    const isInSummary = location.pathname.includes("/summary");

    if ( texts.length !== 0 ) {
        return (
            <div className="eaut-breadcrumb">
                <ul>
                    <li>{isStart ? <span>{texts.breadcrumb_start_page_text}</span> : <Link to="/">{texts.breadcrumb_start_page_text}</Link>}</li>

                    {isInSummary || isInTopic ? <li><Link to="/topics">{texts.breadcrumb_choose_topic_text}</Link></li> : false}
                    {isInTopics ? <li><span to="/topics">{texts.breadcrumb_choose_topic_text}</span></li> : false}

                    {isInSummary ? <li><Link to={`/statement/${topicId}/1`}>{topicName}</Link></li> : false}
                    {isInTopic ? <li><span>{topicName}</span></li> : false}

                    {isInSummary ? <li><span>{texts.breadcrumb_my_strategy_text}</span></li> : false}
                </ul>

                <div className="language-links">
                    <Link to={texts.breadcrumb_fi_link_url}>{texts.breadcrumb_fi_link_text}</Link>
                    <Link to={texts.breadcrumb_sv_link_url}>{texts.breadcrumb_sv_link_text}</Link>
                    <Link to={texts.breadcrumb_en_link_url}>{texts.breadcrumb_en_link_text}</Link>
                </div>

                {isStart ? <Link className="main-site-link" to={texts.general_site_url}>{texts.general_site_name}</Link> : false}
            </div>
        );
    }
};

export default Breadcrumb;
